import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Header from './components/Header';
import Footer from './components/Footer';
import MobileBottomNav from './components/MobileBottomNav';
import Home from './pages/Home';
import Listing from './pages/Listing';
import Detail from './pages/Detail';
import Checkout from './pages/Checkout';
import Confirmation from './pages/Confirmation';
import Wishlist from './pages/Wishlist';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-white flex flex-col">
          <Header />
          <main className="flex-1 pb-20 md:pb-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<Listing />} />
              <Route path="/activity/:id" element={<Detail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/confirmation/:orderId" element={<Confirmation />} />
              <Route path="/wishlist" element={<Wishlist />} />
            </Routes>
          </main>
          <Footer />
          <MobileBottomNav />
          <Toaster position="top-center" />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
